<po-page-edit
  p-title="Revisão Cadastro Produto"
  [p-breadcrumb]="breadcrumb"
>
  <form #formPrincipal="ngForm">
    <po-widget class="po-sm-12 po-md-12 po-lg-12"
      p-title="Informações do Produto - Solicitante"
    >
      <po-combo class="po-sm-12 po-md-12 po-lg-12"
        name="CB1COD"
        p-label="Código"
        [(ngModel)]="preProduto.CB1COD"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrproduto"
        [p-filter-params]="{combobox:'S', CB1MSBLQL: '2'}"
        p-disabled-init-filter="false"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante || processoCadastro.NCODIGO !== 0"
        p-clean="true"
        (p-change)="produtoSelecionado($event)"
        p-change-on-enter="true"
      ></po-combo>
    </po-widget>
    @if (liberaAvancarProcesso){
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Observações"
      >
        <po-textarea class="po-sm-12 po-md-12 po-lg-12"
          name="OBSERVACAO"
          [(ngModel)]="historico"
          p-rows="4"
          p-required="true"
          p-minlength="10"
        ></po-textarea>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="{{ [' ','2'].includes(processoCadastro.CSTATUS) ? 'Cancelar' : 'Recusar' }} Processo"
          p-danger="true"
          (p-click)="cancelarRecusarTela()"
        ></po-button>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="Avançar Processo"
          (p-click)="confirmarTela()"
        ></po-button>
      </po-widget>
    }
  </form>
  <po-divider class="po-row" p-label="Histórico do Processo"></po-divider>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-items]="tabelaHistorico"
    [p-columns]="tabelaHistoricoColunas"
    p-container="true"
    p-spacing="small"
  ></po-table>
</po-page-edit>

<po-page-slide #anexoPageSlide
  p-title="Anexos"
  p-size="xl"
  p-click-out="true">
  <app-util-arquivo #utilArquivo></app-util-arquivo>
</po-page-slide>
